export { default } from './PageAdPlacements.vue'
